/**
 * Brand Repository
 */

import { apiClient } from '../../client'
import type { PaginatedResponse } from '../role.repository'

export interface Brand {
    id: number
    tenant_id: number
    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date
    ref_code?: string
}

export interface CreateBrandRequest {
    tenant_id: number
    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdateBrandRequest {
    tenant_id?: number
    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class BrandRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Brand>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })


        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)

            if (filters.brand_id) params.append('brand_id', filters.brand_id)
        }

        return apiClient.get<PaginatedResponse<Brand>>(`/brands?${params.toString()}`)
    }

    async getById(id: number): Promise<Brand> {
        return apiClient.get<Brand>(`/brands/${id}`)
    }

    async create(data: CreateBrandRequest): Promise<Brand> {
        return apiClient.post<Brand>('/brands', data)
    }

    async update(id: number, data: UpdateBrandRequest): Promise<Brand> {
        return apiClient.put<Brand>(`/brands/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/brands/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters.brand_id) params.append('brand_id', filters.brand_id.toString())

        const baseUrl = `/brands/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;


        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const brandRepository = new BrandRepository()

